import { AppContext } from 'AppContext'
import { Button, Col, Form, Input, Row, Select, Radio, InputNumber } from 'antd'
import client from 'apollo'
import CustomMeta from 'components/CustomMeta'
import { UPDATE_USER, UPDATE_USER_AMC_STRUCTURE } from 'modules/Users/graphql/Mutations'
import { GET_USER_ADDONS } from './graphql/Queries'
import React, { useContext, useEffect, useState } from 'react'
import { COMPLETE_STEP } from './graphql/Mutations'
import openNotification from 'utils/Notification'
import { GET_IMAGES } from 'modules/LoginImages/graphql/Query'
import Loader from 'components/loaders/Loader'
import { useQuery } from '@apollo/react-hooks'
import Page404 from 'components/Page404'
import { random } from 'lodash'
import './SelectTypeFormNew.css'

const FormItem = Form.Item

const SelectTypeFormNew = ({ next }) => {
  const [form] = Form.useForm()
  const { dispatch, state } = useContext(AppContext)
  const [loading, setLoadings] = useState(false)
  const [imageUrl, setImageUrl] = useState('')
  const [reEvaluateValue, setReEvaluateValue] = useState(
    state?.currentUser?.reEvaluate
  )
  const [amcStructure, setAmcStructure] = useState(undefined)
  const [entityStatusValue, setEntityStatusValue] = useState(
    state?.currentUser?.isPanCardIndividual
      ? 'Individual'
      : state?.currentUser?.entityStatus
  )

  const shouldShowAMCFields = entityStatusValue &&
    entityStatusValue !== 'Individual' &&
    entityStatusValue !== 'HUF' &&
    entityStatusValue !== undefined

  const { id } = state.currentUser
  const { data: userAddonsData } = useQuery(GET_USER_ADDONS, {
    variables: { userId: id },
    skip: !id,
    fetchPolicy: 'network-only',
  })

  const editAccessFunc = () => {
    setReEvaluateValue(false)
  }

  useEffect(() => {
    if (userAddonsData?.getUserAddons?.user_amc_structure) {
      try {
        const userData = typeof userAddonsData.getUserAddons.user_amc_structure === 'string'
          ? JSON.parse(userAddonsData.getUserAddons.user_amc_structure)
          : userAddonsData.getUserAddons.user_amc_structure

        if (userData && (userData.amcStructure || userData.frequency || userData.profitSharing)) {
          form.setFieldsValue({
            amcStructure: userData.amcStructure,
            frequency: userData.frequency,
            profitSharing: userData.profitSharing !== undefined && userData.profitSharing !== null
              ? userData.profitSharing
              : 10,
          })
          if (userData.amcStructure) {
            setAmcStructure(userData.amcStructure)
          }
        }
      } catch (err) {
        console.error('Error parsing user_amc_structure:', err)
      }
    }
  }, [userAddonsData, form])

  const onFinish = async (values) => {
    setLoadings(true)
    dispatch({ type: 'IS_ACCEPT_LOADING', data: true })
    let isPanCardIndividual
    if (values?.entityStatus === 'Individual') {
      isPanCardIndividual = true
    } else {
      isPanCardIndividual = false
    }
    const { id } = state.currentUser
    const updateSummaryUiDetails = {
      completedSteps: 'LOGIN_CREATED',
      name: 'Select User Type',
      isDisplayEdit: true,
      data: {
        'Type of Investor': values?.entityStatus
          ? values?.entityStatus
          : 'Individual',
        'PAN No': values?.panCardNo,
      },
    }

    let clientSummaryDetails = [...state.clientSummaryDetails]
    const existingIndex = clientSummaryDetails.findIndex(
      (item) => item.name === 'Select User Type'
    )

    if (existingIndex !== -1) {
      clientSummaryDetails[existingIndex] = updateSummaryUiDetails
    } else {
      clientSummaryDetails.unshift(updateSummaryUiDetails)
    }

    const updateUserData = {
      entityStatus: !isPanCardIndividual ? values.entityStatus : undefined,
      isPanCardIndividual: isPanCardIndividual,
      completedSteps: 'SELECT_USER_TYPE',
      panCardNo: values?.panCardNo,
    }

    // Save AMC structure data if provided
    if (shouldShowAMCFields && values.amcStructure) {
      try {
        const userDataJson = JSON.stringify({
          amcStructure: values.amcStructure || null,
          frequency: values.frequency || null,
          profitSharing: values.profitSharing !== undefined && values.profitSharing !== null
            ? values.profitSharing
            : null,
        })
        await client.mutate({
          mutation: UPDATE_USER_AMC_STRUCTURE,
          variables: {
            userId: id,
            userData: userDataJson,
          },
        })
      } catch (err) {
        console.error('Error saving AMC structure:', err)
      }
    }

    client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          id,
          data: updateUserData,
        },
      })
      .then((res) => {
        client.mutate({
          mutation: COMPLETE_STEP,
          variables: {
            data: {
              step: 'SELECT_USER_TYPE',
              from: 'WEB',
            },
          },
        })
        dispatch({ type: 'CLIENT_SUMMARY_DETAILS', data: clientSummaryDetails })
        dispatch({ type: 'CURRENT_USER', data: res.data.updateUser })
        openNotification('success', 'User type Updated Successfully')
        setLoadings(false)
        dispatch({ type: 'IS_ACCEPT_LOADING', data: false })
        next()
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setLoadings(false)
        dispatch({ type: 'IS_ACCEPT_LOADING', data: false })
      })
  }

  const {
    loading: imageLoading,
    error,
    data,
  } = useQuery(GET_IMAGES, {
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (!imageLoading && data?.getAllLoginImages?.length) {
      setImageUrl(
        data?.getAllLoginImages[random(0, data?.getAllLoginImages?.length - 1)]
          .imageUrl
      )
    }
  }, [data, imageLoading])

  if (error) return <Page404 error={error} />
  if (imageLoading) return <Loader />

  return (
    <>
      <Row className='row-style'>
        <Col sm={24} lg={16} className='col-left disclaimer-col'>
          <div>
            <CustomMeta title='Select User Type' />
            <Row>
              <Col span={22} style={{ textAlign: 'center' }}></Col>
              <Col span={2}>
                {reEvaluateValue && (
                  <Button type='primary' onClick={editAccessFunc}>
                    Edit
                  </Button>
                )}
              </Col>
            </Row>
            <div className='gx-app-login-content verification'>
              <Form
                form={form}
                name='register'
                onFinish={onFinish}
                labelAlign='left'
                scrollToFirstError
                layout='vertical'
                className='client-detail-form'
                initialValues={{
                  entityStatus: state.currentUser?.isPanCardIndividual
                    ? 'Individual'
                    : state?.currentUser?.entityStatus,
                  panCardNo: state?.currentUser?.panCardNo,
                }}
              >
                <div>
                  <FormItem
                    name='entityStatus'
                    label='Type of Investor'
                    rules={[
                      { required: true, message: 'Select Type of Investor' },
                    ]}
                  >
                    <Select
                      placeholder='Select Type of Investor'
                      className='display-field'
                      disabled={!reEvaluateValue ? false : true}
                      defaultValue={state?.currentUser?.entityStatus}
                      placement='bottomLeft'
                      dropdownAlign={{ overflow: { adjustY: false, adjustX: false } }}
                      onChange={(value) => {
                        setEntityStatusValue(value)
                        // Clear AMC structure fields if switching to Individual or HUF
                        if (value === 'Individual' || value === 'HUF') {
                          form.setFieldsValue({
                            amcStructure: undefined,
                            frequency: undefined,
                            profitSharing: 10,
                          })
                          setAmcStructure(undefined)
                        }
                      }}
                      options={[
                        {
                          value: 'Individual',
                          label: 'Individual',
                        },
                        {
                          value: 'HUF',
                          label: 'HUF',
                        },
                        {
                          value: 'LLP',
                          label: 'LLP',
                        },
                        {
                          value: 'partnershipFirm',
                          label: 'Partnership Firm',
                        },
                        {
                          value: 'Corporate',
                          label: 'Corporate',
                        },
                        {
                          value: 'Trust',
                          label: 'Trust',
                        },
                      ]}
                    />
                  </FormItem>

                  <FormItem
                    name='panCardNo'
                    label='PAN No'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your valid Pan number!',
                        pattern: new RegExp(
                          /[A-Za-z]{3}[ABCFGHLJPTFabcfghjpltf]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}/g
                        ),
                      },
                    ]}
                  >
                    <Input
                      placeholder='Enter PAN Card Number'
                      maxLength='10'
                      style={{ textTransform: 'uppercase', backgroundColor: '#fff' }}
                      defaultValue={state?.currentUser?.panCardNo}
                    />
                  </FormItem>
                  {shouldShowAMCFields && (
                    <>
                      <FormItem
                        name='amcStructure'
                        label='AMC Structure'
                        rules={[
                          {
                            required: true,
                            message: 'AMC Structure is required',
                          },
                        ]}
                      >
                        <Radio.Group
                          onChange={(e) => {
                            const value = e.target.value
                            setAmcStructure(value)
                            if (value === 'amc') {
                              form.setFieldsValue({
                                frequency: undefined,
                                profitSharing: 10,
                              })
                              form.validateFields(['frequency', 'profitSharing'])
                            } else if (value === 'profitSharing' || value === 'both') {
                              const currentProfitSharing = form.getFieldValue('profitSharing')
                              if (currentProfitSharing === undefined || currentProfitSharing === null || currentProfitSharing === 10) {
                                form.setFieldsValue({
                                  profitSharing: 10,
                                })
                              }
                              form.validateFields(['frequency', 'profitSharing'])
                            }
                          }}
                          disabled={!reEvaluateValue ? false : true}
                        >
                          <Radio value='amc'>AMC %</Radio>
                          <Radio value='profitSharing'>Profit Sharing</Radio>
                          <Radio value='both'>Both</Radio>
                        </Radio.Group>
                      </FormItem>

                      <FormItem
                        name='frequency'
                        label='Frequency'
                        dependencies={['amcStructure']}
                        rules={[
                          {
                            validator: (_, value) => {
                              const currentAmcStructure = form.getFieldValue('amcStructure')
                              if (
                                currentAmcStructure &&
                                (currentAmcStructure === 'profitSharing' || currentAmcStructure === 'both')
                              ) {
                                if (!value) {
                                  return Promise.reject('Frequency is required')
                                }
                              }
                              return Promise.resolve()
                            },
                          },
                        ]}
                      >
                        <Select
                          placeholder='Select Frequency'
                          disabled={
                            !amcStructure ||
                            (amcStructure !== 'profitSharing' && amcStructure !== 'both')
                          }
                        >
                          <Select.Option value='monthly'>Monthly</Select.Option>
                          <Select.Option value='quarterly'>Quarterly</Select.Option>
                          <Select.Option value='halfYearly'>Half-yearly</Select.Option>
                          <Select.Option value='yearly'>Yearly</Select.Option>
                        </Select>
                      </FormItem>

                      <FormItem
                        name='profitSharing'
                        label='Profit Sharing (%)'
                        initialValue={10}
                        dependencies={['amcStructure']}
                        rules={[
                          {
                            validator: (_, value) => {
                              const currentAmcStructure = form.getFieldValue('amcStructure')
                              if (
                                currentAmcStructure &&
                                (currentAmcStructure === 'profitSharing' || currentAmcStructure === 'both')
                              ) {
                                if (value === null || value === undefined || value === '') {
                                  return Promise.reject('Profit Sharing is required')
                                }
                              }
                              if (value !== null && value !== undefined && value !== '') {
                                if (typeof value === 'number' && value >= 0) {
                                  return Promise.resolve()
                                }
                                return Promise.reject(
                                  'Please enter a valid number (decimals allowed)'
                                )
                              }
                              return Promise.resolve()
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder='Enter Profit Sharing %'
                          disabled={
                            !amcStructure ||
                            (amcStructure !== 'profitSharing' && amcStructure !== 'both')
                          }
                          min={0}
                          step={0.1}
                          precision={2}
                          style={{ width: '100%' }}
                        />
                      </FormItem>
                    </>
                  )}
                </div>
                <div className='verify_next_button'>
                  <Button
                    // id='btn-click'
                    type='primary'
                    className='yes-next-button'
                    htmlType='submit'
                    loading={loading}
                  >
                    Verify And Next
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Col>
        <Col span={8} className='col-right disclaimer-col disclaimer-col-image'>
          <div
            style={{
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={imageUrl} alt='img' />
          </div>
        </Col>
      </Row>
    </>
  )
}

export default SelectTypeFormNew
